import { createSonarSelector } from '@lib/selectors';
import { InitiativeReference } from '@sonar-software/sonar-core';
import { useSonarSelector } from '../useSonarSelector';

const mapSelector = createSonarSelector((state) => state.core.initiatives.byIdMap);

const empty: InitiativeReference = {
	ownerIds: [],
	scopeCounts: {},
	stakeholders: [],
	tagIds: [],
	tasks: []
};

/**
 * Subscribes to the shared state for a particular initiative.
 * @param initiativeId The id of the initiative to subscribe to.
 * @returns A {@link InitiativeReference} instance for the provided id.
 */
export function useInitiativeReference(initiativeId: number): InitiativeReference {
	return useSonarSelector((state) => (mapSelector(state).data ?? {})[ initiativeId ] ?? empty);
}

/**
 * Subscribes to a selection value for a particular initiative shared state.
 * @param initiativeId The id of the initiative to subscribe to.
 * @param select The select method to define the value to subscribe to.
 * @returns The return of the select.
 */
export function useInitiativeReferenceSelect<T>(
	initiativeId: number,
	select: (initiative: InitiativeReference) => T
): T {
	return useSonarSelector((state) => select((mapSelector(state).data ?? {})[ initiativeId ] ?? empty));
}
